export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-telephone-9dc5c8e88e43eb77e1843b818fec8e20.svg";